import * as React from 'react';
// MUIのコンポーネントをインポート
import { Box, Typography, Card, CardActionArea, CardMedia, CardContent } from '@mui/material';
// サンプル画像をインポート
import sampleImg from "../../statics/img/cat240.png";

// カテゴリタイトルの定義
const categoryTitle: string = "〇カテゴリタイトル"

/** user sitemap 表示アイテム */
const USItem = () => {
    return (
        // カードコンポーネントの作成
        <Card sx={{ display: 'flex', margin: 2 }}>
            {/* カードのクリックアクションエリア */}
            <CardActionArea href='/material' target='_blank'>
                <Box>
                    {/* 画像を表示 */}
                    <CardMedia
                        component="img"
                        sx={{ width: '230px', height: '230px' }}
                        image={sampleImg}
                        alt=""
                    />
                    {/* カードの内容 */}
                    <CardContent>
                        {/* 説明文を表示 */}
                        <Typography variant='subtitle2'>
                            資料解説文資料解説文資料解説文資料解説文資料解説文。
                        </Typography>
                    </CardContent>
                </Box>
            </CardActionArea>
        </Card>
    );
}

export default USItem;